// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"c6e81542","115":"355e02cd","287":"c6e81542","594":"10192238","887":"79332f6a"}[chunkId] + ".chunk.css";
};